import { Grid, theme as antdTheme } from "antd";

export const useAntTheme = () => {
    const { useToken } = antdTheme;
    const { token: theme } = useToken();
    const breakpoint = Grid.useBreakpoint();
    const isMobile =
      typeof breakpoint.lg === "undefined" ? false : !breakpoint.lg;
  
    return {theme, isMobile}
}
